{
  "title": "Admin Settings",
  "adminAccess": "Admin Access",
  "userProfile": "User Profile",
  "name": "Name:",
  "email": "Email:",
  "role": "Role:",
  "systemInformation": "System Information",
  "systemInfoDesc": "Application version and system details would go here.",
  "noAdminAccess": "You do not have admin access. Contact your system administrator for administrative features.",
  "scrapingSchedules": "Scraping Schedules",
  "user": "User",
  "scrapingTime": "Scraping Time",
  "status": "Status",
  "scheduled": "Scheduled",
  "notConfigured": "Not Configured",
  "loading": "Loading...",
  "noUsers": "No users found.",
  "errorLoading": "Failed to load scraping schedules",
  "dash": "\u2014"
}
